const relationshipToCampersOptions = [
  'Mother',
  'Father',
  'Parent',
  'Stepmother',
  'Stepfather',
  'Stepparent',
  'Grandmother',
  'Grandfather',
  'Grandparent',
  'Sister',
  'Brother',
  'Aunt',
  'Uncle',
  'Cousin',
  'Family Friend',
  'Neighbor',
  'Nanny',
  'Babysitter',
  'Assistant',
  'Secretary',
  'Coworker',
  'Legal Guardian'
]

export { relationshipToCampersOptions }
